<template>
    <div v-if="$page.props.auth.user">
        <div class="ml-3 relative">
            <jet-dropdown align="right" width="48">
                <template #trigger>
                    <v-card style="border-radius: 50px">
                        <button
                            class="flex align-center text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out"
                        >
                            <img
                                class="h-8 w-8 rounded-full object-cover"
                                :src="$page.props.auth.user.profile_photo_url"
                                :alt="$page.props.auth.user.name"
                            />
                            <div
                                class="mx-1 soli-grey flex align-center"
                                style="line-height: 12px"
                            >
                                {{ $page.props.auth.user.first_name }}
                            </div>
                            <v-icon dense class="soli-grey">expand_more</v-icon>
                        </button>
                    </v-card>
                </template>

                <template #content>
                    <a
                        v-if="$page.props.auth.user"
                        :href="`/profile/${$page.props.auth.user.id}/account`"
                        class="soli-round soli-grey block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                    >
                        View Profile
                    </a>
                    <a
                        href="/help-articles"
                        class="soli-round soli-grey block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                        >Help</a
                    >
                    <a
                        v-if="$page.props.auth.user"
                        @click="composeEmail = true"
                        class="soli-round soli-grey block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                        >Share Feedback</a
                    >
                    <a
                        href="/logout"
                        class="error--text soli-round block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                    >
                        Logout
                    </a>
                </template>
            </jet-dropdown>
        </div>
        <ComposeEmail
            v-if="composeEmail"
            :emails="['feedback@musicologie.com']"
            :errors="errors"
            :user="$page.props.auth.user"
            @success="emailSuccess()"
            @reset="closeModal(() => (composeEmail = false))"
        />
    </div>
</template>

<script>
import JetDropdown from "../../Jetstream/Dropdown.vue";
import JetDropdownLink from "./../../Jetstream/DropdownLink";
import ComposeEmail from "../Users/ComposeEmail.vue";

export default {
    components: {
        JetDropdown,
        JetDropdownLink,
        ComposeEmail,
    },
    props: ["errors"],
    data() {
        return {
            composeEmail: false,
        };
    },
    methods: {
        emailSuccess() {
            this.$emit("success");
            this.closeModal(() => (this.composeEmail = false));
        },
    },
};
</script>
